import React from "react";

function Loading() {
  return (
    <section className="cardSection _eventPrompt _loading">
      <p className="bit">Loading</p>
      <div className="animatedDot"><span></span></div>
    </section>
  )
}

export default Loading;



// WEBPACK FOOTER //
// ./src/features/shared/components/misc/Loading.js